import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ImageButtonList from "../common/imageButtonList";
import ImageText from "../common/imageText";
import NavigationBar from "../common/navigationBar";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as applicationActions from "../../actions/application";

class ProcedureList extends Component {
  /**************
   * Properties *
   **************/
  state = {
    procedure: this.props.currentPatient,
    default: [
      {
        id: "procedure1",
        to: "/scheduled_procedures/details/hipXRay/1",
        highlight: require("./images/bar_hip_xray_HL.png"),
        unhighlight: require("./images/bar_hip_xray_UH.png"),
      },
      {
        id: "procedure2",
        to: "/scheduled_procedures/details/chestXRay/1",
        highlight: require("./images/bar_chest_xray_HL.png"),
        unhighlight: require("./images/bar_chest_xray_UH.png"),
      },
    ],
    orthoPatient: [
      {
        id: "procedure1",
        to: "/scheduled_procedures/details/hipXRay/1",
        highlight: require("./images/bar_hip_xray_HL.png"),
        unhighlight: require("./images/bar_hip_xray_UH.png"),
      },
      {
        id: "procedure2",
        to: "/scheduled_procedures/details/chestXRay/1",
        highlight: require("./images/bar_chest_xray_HL.png"),
        unhighlight: require("./images/bar_chest_xray_UH.png"),
      },
    ],
    chfPatient: [
      {
        id: "procedure1",
        to: "/scheduled_procedures/details/chestXRay/1",
        highlight: require("./images/bar_chest_xray_HL.png"),
        unhighlight: require("./images/bar_chest_xray_UH.png"),
      },
      {
        id: "procedure2",
        to: "/scheduled_procedures/details/echocardiogram/1",
        highlight: require("./images/bar_echocardiogram_HL.png"),
        unhighlight: require("./images/bar_echocardiogram_UH.png"),
      },
      {
        id: "procedure3",
        to: "/scheduled_procedures/details/bloodTest/1",
        highlight: require("./images/bar_bloodtest_HL.png"),
        unhighlight: require("./images/bar_bloodtest_UH.png"),
      },
    ],
    pediatricPatient: [
      {
        id: "procedure1",
        to: "/scheduled_procedures/details/chestXRay/1",
        highlight: require("./images/bar_chest_xray_HL.png"),
        unhighlight: require("./images/bar_chest_xray_UH.png"),
      },
      {
        id: "procedure2",
        to: "/scheduled_procedures/details/pulmonary/1",
        highlight: require("./images/bar_pulmonary_HL.png"),
        unhighlight: require("./images/bar_pulmonary_UH.png"),
      },
    ],
    oncologyPatient: [
      {
        id: "procedure1",
        to: "/scheduled_procedures/details/bloodtestBedside/1",
        highlight: require("./images/bar_bloodtestBedside_HL.png"),
        unhighlight: require("./images/bar_bloodtestBedside_UH.png"),
      },
      {
        id: "procedure2",
        to: "/scheduled_procedures/details/petScan/1",
        highlight: require("./images/bar_PETScan_HL.png"),
        unhighlight: require("./images/bar_PETScan_UH.png"),
      },
    ],
    textImage: require("./images/1259_elements_procedures.png"),
    navigationBar: {
      back: true,
      backRoute: "/main_menu",
      mainMenu: true,
      navigate: true,
    },
  };

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    let procedureList = null;
    switch (this.state.procedure) {
      case "orthoPatient":
        procedureList = this.state.orthoPatient;
        break;
      case "chfPatient":
        procedureList = this.state.chfPatient;
        break;
      case "pediatricPatient":
        procedureList = this.state.pediatricPatient;
        break;
      case "oncologyPatient":
        procedureList = this.state.oncologyPatient;
        break;
      default:
        procedureList = this.state.default;
    }
    return (
      <div className="procedure-list">
        <ImageText id="text" src={this.state.textImage} />
        <ImageButtonList
          imageButtons={procedureList}
          flexClass="flex-vertical"
        />
        <NavigationBar {...this.state.navigationBar} />
      </div>
    );
  }
}

const ConnectedProcedureList = connect(
  (state) => ({
    context: state.application.currentContext,
    currentPatient: state.application.currentPatient,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(ProcedureList);

export default withRouter(ConnectedProcedureList);
